import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller, useFieldArray, FormProvider } from "react-hook-form";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { Container, Paper, Title, Divider, Grid, Button, Group, Text, Stack, Input, Checkbox, TextInput } from '@mantine/core';
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { FiUser, FiMail, FiPhone, FiCreditCard, FiDollarSign, FiCalendar, FiClock, FiHome } from 'react-icons/fi';

import { RHFTextInput, RHFSelect, RHFCheckbox, RHFTextarea, RHFGoogleAddress, RHFCustomDatePicker, RHFNumberInput } from "./FormComponents";
import './enrollment.css'
import base_url from "../../api/bootapi";
import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import CustomerForm from "./CustomerForm";



// Reusable inline style for the country/region selects to match Mantine's inputs
const selectStyle = {
    width: '100%',
    height: '40px',
    padding: '0 12px',
    borderRadius: '4px',
    border: '1px solid #ced4da',
    fontSize: '14px',
    backgroundColor: '#fff',
    fontFamily: 'inherit'
};

const ticketOptions = [
    { label: "First", value: "First" },
    { label: "Business", value: "Business" },
    { label: "Premium", value: "Premium" },
    { label: "Economy Class (Cost will be advised)", value: "Economy Class" }
];

const TourTripEnrollmentBulk = () => {
    const { tour_url_name, sub_Tour_url_name } = useParams();



    const navigate = useNavigate();
    const [backdropopen, setbackdropopen] = useState(false);

    const [tourId, setTourId] = useState(null);
    const [tourList, setTourList] = useState([])
    const [subTourList, setSubTourList] = useState([]);
    const [subTourId, setSubTourId] = useState(null);


    // --- API & Core State ---
    const [loading, setLoading] = useState(false);
    const [tourDetails, setTourDetails] = useState(null);
    const [mainTourDetails, setMainTourDetails] = useState(null);

    // --- Custom Component States ---
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");

    const [cardDetails, setCardDetails] = useState({
        card_number: null,
        card_expiry_year: null,
        card_cvv: null,
    });

    const { wrapperProps, getCardImageProps, getCardNumberProps, getExpiryDateProps, getCVCProps } = usePaymentInputs();

    const customerTemplate = {
        first_name: "", last_name: "", middle_name: "", gender: "", date_of_birth: null,
        email_address: "", mobile_number: "", passport_number: "", passport_expiration_date: null,
        city: "", state: "", zip: "", country: "United States",
        options: { fullPackage: false, accommodation: false, singleRoomCost: false, insurance: false, otherCost: false },
        special_ticket_preference: "",
        customer_tour: '',
        payment_method: "", card_holder_name: "", sameAsAbove: false,
        depositRequired: false, enableExtraDeposit: false, extraDepositAmount: "", address: "",
    }
    // --- Form Initialization ---

    const methods = useForm({
        defaultValues: {
            customers: [customerTemplate],
            billing: { city: "", state: "", zip: "", country: "United States" },
            remarks: "",
            payment_method: ""
        }
    });

    const { control, handleSubmit, watch, setValue, reset, formState: { errors } } = methods

    const { fields, append, remove } = useFieldArray({
        control,
        name: "customers",
    });


    const paymentMethod = watch("payment_method");
    const sameAsAbove = watch("sameAsAbove");


    const selectedBillingCountry = watch("billing.country");
















    // --- Address Logic ---
    const parseAddressComponents = (components = []) => {
        const result = { city: "", state: "", postalCode: "", country: "" };
        components.forEach((c) => {
            if (c.types.includes("locality") || (!result.city && c.types.includes("sublocality_level_1")) || (!result.city && c.types.includes("administrative_area_level_2"))) {
                result.city = c.long_name;
            }
            if (c.types.includes("administrative_area_level_1")) result.state = c.long_name;
            if (c.types.includes("postal_code")) result.postalCode = c.long_name;
            if (c.types.includes("country")) result.country = c.long_name;
        });
        return result;
    };

    const onPlaceSelect_JS = (val, main = true) => {
        if (!val) {
            if (main) { setValue("city", ""); setValue("zip", ""); setValue("state", ""); setValue("country", ""); }
            else { setValue("billing.city", ""); setValue("billing.zip", ""); setValue("billing.state", ""); setValue("billing.country", ""); }
            return;
        }
        let placeId = typeof val === 'object' ? val.value : val;
        if (!window.google || !placeId) return;

        const ps = new window.google.maps.places.PlacesService(document.createElement("div"));
        ps.getDetails({ placeId, fields: ["address_components"] }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                const parsed = parseAddressComponents(place.address_components || []);
                if (main) {
                    setValue("city", parsed.city || ""); setValue("zip", parsed.postalCode || "");
                    setValue("state", parsed.state || ""); setValue("country", parsed.country || "United States");
                } else {
                    setValue("billing.city", parsed.city || ""); setValue("billing.zip", parsed.postalCode || "");
                    setValue("billing.state", parsed.state || ""); setValue("billing.country", parsed.country || "United States");
                }
            }
        });
    };


    useEffect(() => { onPlaceSelect_JS(address2, false); }, [address2]);


    useEffect(() => {
        setbackdropopen(true);

        if (tour_url_name) {

            getMainTourDetails();
        }

        if (sub_Tour_url_name) {
            getSubTourDetails();
        }

    }, [tour_url_name, sub_Tour_url_name]);

    const minimumDeposit = Number(tourDetails?.minimum_deposit || 0);
    const minimumDepositRequired = tourDetails?.minimum_deposit_mandatory || false;






    const extractTourData = (tour) => ({
        full_package_price: tour?.full_package_price,
        accommodation_only_price: tour?.accommodation_only_price,
        single_room_cost: tour?.single_room_cost,
        insurance_price: tour?.insurance_price,
        tour_long_descript: tour?.tour_long_descript,
        tour_names: tour?.tour_names,
        id: tour?.id,
        minimum_deposit_mandatory: tour?.minimum_deposit_mandatory,
        minimum_deposit: tour?.minimum_deposit,
        value: String(tour?.id),
        label: tour?.tour_names || "Unnamed Tour",
        duartion_start_date: tour?.duartion_start_date,
        duartion_end_date: tour?.duartion_end_date
    });

    const extractSubTourData = (tour) => ({
        full_package_price: tour?.full_package_price,
        accommodation_only_price: tour?.accommodation_only_price,
        single_room_cost: tour?.single_room_cost,
        insurance_price: tour?.insurance_price,
        tour_long_descript: tour?.tour_long_descript,
        tour_names: tour?.sub_tour_names,
        id: tour?.id,
        value: String(tour?.id),
        minimum_deposit_mandatory: tour?.minimum_deposit_mandatory,
        minimum_deposit: tour?.minimum_deposit,
        label: tour?.sub_tour_names || "Unnamed Tour",
        duartion_start_date: tour?.duartion_start_date,
        duartion_end_date: tour?.duartion_end_date
    });


    const getMainTourDetails = async () => {
        axios.get(`${base_url.api1}/tourapp/get_trip?url_name=${tour_url_name}`)
            .then((res) => {
                const data = res.data.Tour[0];

                let mainTour = extractTourData(data)

                const subTours = (data?.sub_tours || []).map(extractSubTourData);
                setSubTourList(subTours);

                const tourList = [mainTour, ...subTours];

                setTourList(tourList);
                setTourId(data?.id)
                if (!sub_Tour_url_name) {


                    setTourDetails(data);
                    setMainTourDetails(data);

                }
                setValue("payment_method", data?.payment_methods?.[0] || "Cash");

            }).catch((e) => {
                console.log(e.message)
            })
            .finally(() => setbackdropopen(false));
    }

    const getSubTourDetails = async () => {
        axios.get(`${base_url.api1}/tourapp/subtour?url_name=${sub_Tour_url_name}`)
            .then((res) => {
                const data = res.data.SubTour[0];
                setSubTourId(data?.id)
                setValue('payment_method', data?.payment_methods?.[0] || "Cash")


                setTourDetails(data);


            }).catch((e) => {
                console.log(e.message)
            })
            .finally(() => setbackdropopen(false));
    }



    const formatName = (name) => {
        if (typeof name !== 'string' || !name.trim()) return "";
        return name.trim().charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    };


    const getAddressValue = (addr) =>
        typeof addr === 'object' ? addr?.label ?? '' : addr ?? '';


    const formatApiDate = (dateStr) => {
        if (!dateStr) return null;
        return moment(dateStr, "MM/DD/YYYY").format("YYYY-MM-DDThh:mm:ss");
    };

    const formatToDate = (dateStr) => {
        if (!dateStr) return null;
        return moment(dateStr, "MM/DD/YYYY").format("YYYY-MM-DD");
    };


    const onSubmit = async (data) => {
        const invalidPackageCustomer = data.customers.find(
            customer =>
                !customer.options?.fullPackage &&
                !customer.options?.accommodation
        );

        if (invalidPackageCustomer) {
            Swal.fire({
                icon: "error",
                title: "Please select Full Package or Accommodation for all customers",
            });
            return;
        }
        // 2. Deposit Validation
        if (minimumDepositRequired) {
            const invalidDepositCustomer = data.customers.find(
                customer => !customer.depositRequired
            );

            if (invalidDepositCustomer) {
                Swal.fire({
                    icon: "error",
                    title: "Minimum Deposit is Required",
                });
                return;
            }
        }
        let card_expiry_month = null;
        let card_expiry_year = null;

        const requiresCardPayment = paymentMethod === "Card"

        if (requiresCardPayment) {
            if (!cardDetails.card_number) {
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card number is required",
                });
                return;
            }

            if (!cardDetails.card_expiry_year) {
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card expiry date is required",
                });
                return;
            }

            if (!cardDetails.card_cvv) {
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card CVV is required",
                });
                return;
            }

            const expiryParts = cardDetails.card_expiry_year
                .replace(/\s/g, "")
                .split("/");

            if (expiryParts.length === 2) {
                card_expiry_month = expiryParts[0];
                card_expiry_year = expiryParts[1];
            }
        }

        const firstTraveler = data.customers?.[0];
        const payloadData = data.customers.map((customer) => {

            const tourDetails = tourList?.find((tour) => String(tour.id) === String(customer?.customer_tour));
            const matchedSubTourObject = subTourList?.find((tour) => String(tour.id) === String(customer?.customer_tour));


            return {
                tour_id: tourId,
                sub_tour_id: matchedSubTourObject
                    ? customer?.customer_tour
                    : null,

                trip_start_date: tourDetails?.duartion_start_date ? moment(tourDetails.duartion_start_date).format("YYYY-MM-DDThh:mm:ss") : null,
                trip_end_date: tourDetails?.duartion_end_date ? moment(tourDetails.duartion_end_date).format("YYYY-MM-DDThh:mm:ss") : null,
                mode_of_tour: customer?.mode_of_tour, // Assuming this is set somewhere in your form
                number_of_participants_with_airfare: "1",
                number_of_participants_with_out_airfare: "0",
                intrested_tour: tourDetails?.tour_names,
                nationality: customer?.country,
                enquiry_status: "Pending",
                place_of_birth: customer?.country,
                state: customer?.state,
                user: 1, // Static as per your original code

                // Personal Details
                first_name: formatName(customer?.first_name),
                middle_name: formatName(customer?.middle_name),
                last_name: formatName(customer?.last_name),
                gender: customer?.gender,
                email_address: firstTraveler?.email_address,
                phone_number: firstTraveler?.mobile_number,
                date_of_birth: formatToDate(customer?.date_of_birth),
                passport_number: customer?.passport_number,
                passport_expiration_date: formatApiDate(customer?.passport_expiration_date),

                // Primary Address
                city: formatName(customer?.city),
                address: formatName(getAddressValue(customer?.address)),
                zip: customer?.zip,

                // Options
                accommodation_only: customer?.options.accommodation,
                single_room_cost_only: customer?.options.singleRoomCost,
                other_cost_included: customer?.options.otherCost,
                full_package: customer?.options.fullPackage,
                insurance: customer?.options.insurance,
                remarks: data?.remarks,
                single_room_cost: tourDetails?.single_room_cost || 0,
                special_ticket_preference: customer?.special_ticket_preference,
                special_ticket_price: null,

                // Payment Details
                payment_method: data?.payment_method,
                advance_payment: customer?.advance_payment, // Uses the calculation we built earlier

                // Card Specifics
                card_holder_name: (data?.payment_method === "Card" && customer?.advance_payment > 0) ? formatName(data?.card_holder_name) : null,


                // Billing Address
                billing_address: data?.payment_method !== "Zelle" ? formatName(sameAsAbove ? getAddressValue(customer?.address) : getAddressValue(address2)) : null,
                billing_city: data?.payment_method !== "Zelle" ? (sameAsAbove ? formatName(customer?.city) : formatName(data?.billing.city)) : null,
                billing_state: data?.payment_method !== "Zelle" ? (sameAsAbove ? customer?.state : data?.billing.state) : null,
                billing_zip: data?.payment_method !== "Zelle" ? (sameAsAbove ? customer?.zip : data?.billing.zip) : null,
                billing_country: data?.payment_method !== "Zelle" ? (sameAsAbove ? customer?.country : data?.billing.country) : null,
            }
        });

        // 4. Construct API Payload




        const submitData = {
            enquiries: payloadData,
            card_number: data.payment_method === "Card" ? cardDetails.card_number : null,
            card_cvv: data.payment_method === "Card" ? cardDetails.card_cvv : null,
            card_expiry_month: card_expiry_month,
            card_expiry_year: card_expiry_year,
        };

        // 5. Submit Form
        setbackdropopen(true); // Optional: If you have a loading state for a spinner

        try {
            const formData = new FormData();
            formData.append("data", JSON.stringify(submitData));

            const response = await axios.post(`${base_url.api1}/tourapp/trip_enquiry_bulk`, formData);

            if (response.status === 200) {
                navigate("/thank-you-page", {
                    state: {
                        isClaimed: 3,
                        unique_no: data.mobile_number,
                        message: response?.data?.message || response?.data?.success_message
                    },
                });
                reset(); // Resets React Hook Form
                setAddress1("");
                setAddress2("");
            } else {
                navigate("/thank-you-page", {
                    state: {
                        isClaimed: 4,
                        unique_no: data.mobile_number,
                        message: response?.data?.error_message ?? response?.data?.message,
                    },
                });
                reset();
            }
        } catch (error) {
            if (error?.response?.status >= 400 && error?.response?.status < 500) {
                Swal.fire({
                    icon: "error",
                    title: error?.response?.data?.message || "Oops...",
                    text: "Something went wrong!",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        } finally {
            setbackdropopen(false);
        }
    };


    const customers = watch("customers") || [];

    const getCustomerTotal = (customer) => {

        const tourDetails = tourList?.find((tour) => String(tour.id) === String(customer?.customer_tour));

        const options = customer?.options || {};



        let total = 0;

        if (options.fullPackage)
            total += Number(tourDetails?.full_package_price || 0);

        if (options.accommodation)
            total += Number(tourDetails?.accommodation_only_price || 0);

        if (options.singleRoomCost)
            total += Number(tourDetails?.single_room_cost || 0);

        if (options.insurance)
            total += Number(tourDetails?.insurance_price || 0);

        if (options.otherCost)
            total += Number(tourDetails?.other_cost || 0);

        return total;
    };

    const getCustomerTotalAdvance = (customer) => {

        const options = customer?.options || {};
        if (!options.fullPackage && !options.accommodation) {
            return 0
        }

        return Number(customer?.advance_payment);
    };

    const grandTotal = customers.reduce(
        (sum, customer) => sum + getCustomerTotal(customer),
        0
    );


    const grandTotalAdvance = customers.reduce(
        (sum, customer) => sum + getCustomerTotalAdvance(customer),
        0
    );


    return (
        <div style={{ backgroundColor: "#F5F6FA" }}>
            <React.Fragment>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={backdropopen}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Nav />

            </React.Fragment>


            <Container size="xl" py="xl" style={{ backgroundColor: "#F5F6FA" }}>
                <Paper shadow="md" p="lg" radius="md">
                    <Title order={2} mb="md">{sub_Tour_url_name ? tourDetails?.sub_tour_names || "Tour Enrollment" : tourDetails?.tour_names || "Tour Enrollment"}</Title>
                    <FormProvider {...methods}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {fields.map((field, index) => (
                                <CustomerForm
                                    paymentMethod={paymentMethod}
                                    key={field.id}
                                    index={index}
                                    remove={remove}
                                    tourDetails={tourDetails}
                                    tourList={tourList}
                                />
                            ))}

                            <Button
                                mt="md"
                                type="button"
                                onClick={() => append(customerTemplate)}
                            >
                                Add Traveler
                            </Button>

                            <Paper shadow="sm" withBorder p="md" mt="xl">
                                <Title order={4}>Travelers Cost Summary</Title>

                                {customers.map((customer, index) => (
                                    <Group
                                        key={index}
                                        justify="space-between"
                                        mt="xs"
                                    >
                                        <Text>
                                            {customer.first_name || `Traveler ${index + 1}`}
                                        </Text>

                                        <Text fw={600}>
                                            ${getCustomerTotal(customer)}
                                        </Text>
                                    </Group>
                                ))}

                                <Divider my="sm" />

                                <Group justify="space-between">
                                    <Text fw={700}>Grand Total Cost Summary</Text>

                                    <Text fw={700}>
                                        ${grandTotal}
                                    </Text>
                                </Group>


                            </Paper>


                            <Paper shadow="sm" p="md" mt="xl" withBorder bg="gray.0">
                                <Title order={4}>Travelers Advance Payments</Title>

                                {customers.map((customer, index) => (
                                    <Group
                                        key={index}
                                        justify="space-between"
                                        mt="xs"
                                    >
                                        <Text>
                                            {customer.first_name || `Traveler ${index + 1}`}
                                        </Text>

                                        <Text fw={600}>
                                            ${getCustomerTotalAdvance(customer)}
                                        </Text>
                                    </Group>
                                ))}

                                <Divider my="sm" />

                                <Group justify="space-between">
                                    <Text fw={700}>Grand Total Advance</Text>

                                    <Text fw={700}>
                                        ${grandTotalAdvance}
                                    </Text>
                                </Group>

                                <Divider my="sm" />
                                <Grid align="flex-end">
                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <RHFSelect control={control} name="payment_method" label="Payment Method" data={tourDetails?.payment_methods?.length > 0 ? tourDetails?.payment_methods : ["Cash", "Card", "Check", "Zelle"]} />

                                    </Grid.Col>




                                </Grid>
                            </Paper>




                            {paymentMethod === "Card" && (
                                <>
                                    <Title order={4} mt="xl">Credit Card Details</Title>
                                    <Divider my="sm" />
                                    <Grid>
                                        <Grid.Col span={{ base: 12, md: 4 }}>
                                            <RHFTextInput control={control} name="card_holder_name" label="Name on Card" withAsterisk rules={{ required: "Required" }} />
                                        </Grid.Col>
                                        <Grid.Col span={{ base: 12, md: 4 }}>
                                            <Input.Wrapper label="Card Number" withAsterisk>
                                                <TextInput
                                                    rightSection={<svg {...getCardImageProps({ images })} style={{ width: "24px", height: "auto" }} />}
                                                    rightSectionWidth={40}
                                                    styles={{

                                                        input: {
                                                            height: '40px'
                                                        }
                                                    }}
                                                    {...getCardNumberProps({ onChange: (e) => setCardDetails(prev => ({ ...prev, card_number: e.target.value })) })}
                                                />
                                            </Input.Wrapper>
                                        </Grid.Col>
                                        <Grid.Col span={{ base: 6, md: 2 }}>
                                            <Input.Wrapper label="Expiry Date" withAsterisk>
                                                <TextInput styles={{

                                                    input: {
                                                        height: '40px'
                                                    }
                                                }}{...getExpiryDateProps({ onChange: (e) => setCardDetails(prev => ({ ...prev, card_expiry_year: e.target.value })) })} />
                                            </Input.Wrapper>
                                        </Grid.Col>
                                        <Grid.Col span={{ base: 6, md: 2 }}>
                                            <Input.Wrapper label="CVV" withAsterisk>
                                                <TextInput styles={{

                                                    input: {
                                                        height: '40px'
                                                    }
                                                }} {...getCVCProps({ onChange: (e) => setCardDetails(prev => ({ ...prev, card_cvv: e.target.value })) })} />
                                            </Input.Wrapper>
                                        </Grid.Col>
                                    </Grid>

                                    <Title order={4} mt="xl">Billing Address</Title>
                                    <Divider my="sm" />
                                    <RHFCheckbox control={control} name="sameAsAbove" label="Same as Personal Address" mt="xs" mb="md" />
                                    {!sameAsAbove && (
                                        <Grid>
                                            <Grid.Col span={{ base: 12, md: 3 }}>
                                                <Input.Wrapper label="Billing Address">
                                                    <RHFGoogleAddress googleAddress={address2?.label} setGoogleAddress={setAddress2} isRequired={false} />
                                                </Input.Wrapper>
                                            </Grid.Col>
                                            <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name="billing.city" label="City" /></Grid.Col>
                                            <Grid.Col span={{ base: 12, md: 3 }}><RHFTextInput control={control} name="billing.zip" label="Zip" /></Grid.Col>

                                            <Grid.Col span={{ base: 12, md: 3 }}>
                                                <Input.Wrapper label="Country">
                                                    <Controller name="billing.country" control={control} render={({ field }) => (
                                                        <CountryDropdown style={selectStyle} defaultOptionLabel="- Select Country -" value={field.value} onChange={(val) => { field.onChange(val); setValue('billing.state', ''); }} />
                                                    )}
                                                    />
                                                </Input.Wrapper>
                                            </Grid.Col>

                                            <Grid.Col span={{ base: 12, md: 3 }}>
                                                <Input.Wrapper label="State">
                                                    <Controller name="billing.state" control={control} render={({ field }) => (
                                                        <RegionDropdown country={selectedBillingCountry} style={selectStyle} defaultOptionLabel="- Select State -" value={field.value} onChange={(val) => field.onChange(val)} />
                                                    )}
                                                    />
                                                </Input.Wrapper>
                                            </Grid.Col>
                                        </Grid>
                                    )}
                                </>
                            )}

                            <Title order={4} mt="xl">Additional Information</Title>
                            <Divider my="sm" />
                            <Grid>
                                <Grid.Col span={{ base: 12, md: 6 }}><RHFTextarea control={control} name="remarks" label="Remarks / Special Requests" minRows={4} /></Grid.Col>
                            </Grid>

                            {/* Submit Actions */}
                            <Group position="right" mt="xl">
                                <Button variant="outline" onClick={() => reset()} disabled={loading}>Reset</Button>
                                <Button type="submit" loading={loading} color="blue">Submit Enrollment</Button>
                            </Group>

                        </form>

                    </FormProvider>
                </Paper>
            </Container>

            <FooterNew />

        </div>
    );
};

export default TourTripEnrollmentBulk;